import React, { useState, useRef, useEffect, useMemo } from "react";
import SC from "./style";
import InnoIcons from "@InnoIcons/";

const SavedFilterDropdown = ({
  label = "",
  options = [],
  selectedId,
  onSelectionChange,
  handleClear = () => {},
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const dropdownRef = useRef();

  // Filter options based on search
  const filteredOptions = useMemo(() => {
    const lowerSearch = searchTerm.toLowerCase();
    return options.filter((option) =>
      option.filterName.toLowerCase().includes(lowerSearch)
    );
  }, [options, searchTerm]);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Close on Escape
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") setIsOpen(false);
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, []);

  const selectedFilter = options.find((f) => f.id === selectedId);

  return (
    <SC.DropdownContainer ref={dropdownRef}>
      <SC.DropdownButton
        isOpen={isOpen}
        onClick={() => setIsOpen(!isOpen)}
        isActive={!!selectedId}
      >
        {selectedFilter ? selectedFilter.filterName : "Saved filters"}
        <SC.ChevronIcon isOpen={isOpen} isActive={!!selectedId} />
      </SC.DropdownButton>

      <SC.DropdownMenu isOpen={isOpen}>
        {/* Search Box */}
        <SC.SearchContainer>
          <SC.SearchIcon />
          <SC.SearchInput
            placeholder="Search..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </SC.SearchContainer>

        {/* Options List */}
        <SC.OptionsList>
          {filteredOptions.map((option) => (
            <SC.OptionItem
              key={option.id}
              onClick={() => {
                onSelectionChange(option);
                setIsOpen(false);
              }}
              style={{
                backgroundColor:
                  option.id === selectedId ? "#fef3c7" : "transparent",
                color: option.id === selectedId ? "#92400e" : "#374151",
              }}
            >
              {option.filterName} {option.isDefault ? "(Default)" : ""}
            </SC.OptionItem>
          ))}
        </SC.OptionsList>

        {/* Footer */}
        <SC.DropdownFooter>
          <SC.ClearAllButton
            onClick={() => {
              handleClear(); // Reset parent state
              setIsOpen(false); // Close dropdown
            }}
          >
            Clear All
          </SC.ClearAllButton>
        </SC.DropdownFooter>
      </SC.DropdownMenu>
    </SC.DropdownContainer>
  );
};

export default SavedFilterDropdown;
